import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { EnergyLabelUI } from "./EnergyLabelUI";

export const EnergyLabel = ({
  product,
  className,
  flags,
}: Pick<StandardProps, "product" | "flags"> & { className?: string }) => {
  const { variant } = useVariant(product);

  if (!variant.energy) {
    return null;
  }

  const {
    label,
    informationSheet,
    rating: { legacy, value },
  } = variant.energy;

  return (
    <EnergyLabelUI
      className={className}
      informationSheet={informationSheet || undefined}
      isLegacy={!!legacy}
      label={label || undefined}
      rating={value}
      openDrawerEvent={flags.energyLabelOnOpenDrawerEvent.value as string}
      closeDrawerEvent={flags.energyLabelOnCloseDrawerEvent.value as string}
    />
  );
};
